import moment from 'moment';
import React, { createContext, useContext, useState, ReactNode } from 'react';

interface TherapyPlanningContextProps {
  weekStartDate: moment.Moment;
  setWeekStartDate: React.Dispatch<React.SetStateAction<moment.Moment>>;
  setWeekEndDate: React.Dispatch<React.SetStateAction<moment.Moment>>;
  weekEndDate: moment.Moment;
  currentIndex: any;
  setCurrentIndex: any;
}

const TherapyPlanningContext = createContext<TherapyPlanningContextProps | undefined>(undefined);

export const TherapyPlanningProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [weekStartDate, setWeekStartDate] = useState(moment().clone().startOf('week'));
  const [weekEndDate, setWeekEndDate] = useState(moment().clone().endOf('week'));
  const [currentIndex, setCurrentIndex] = useState(0);

  const TherapyPlanningValue: TherapyPlanningContextProps = {
    weekStartDate,
    setWeekStartDate,
    setWeekEndDate,
    weekEndDate,
    currentIndex,
    setCurrentIndex,
  };

  return (
    <TherapyPlanningContext.Provider value={TherapyPlanningValue}>
      {children}
    </TherapyPlanningContext.Provider>
  );
};

export const useTherapyPlanning = (): TherapyPlanningContextProps => {
  const context = useContext(TherapyPlanningContext);
  if (!context) {
    throw new Error('useTherapyPlanning must be used within a TherapyPlanningProvider');
  }
  return context;
};
